import { Component, useEffect, useState, useContext } from "react";
import Button from "../buttons/buttons";
import Form from "../form/form";
import MyContext from "../../globalState/globalState";
import { stripHtmlTags, truncateText } from "../../funcoes/Funcoes";

function CardProductsV2({
  item,
  card,
  index,
  tipo,
  layout,
  img,
  destaque,
  log,
  planoPag,
}) {
  const contexto = useContext(MyContext);
  const [ready, setReady] = useState(false);
  let preco = 0.0;
  const [precoPor, setPrecoPor] = useState("");
  const [precoDe, setPrecoDe] = useState("");
  const [titulo, setTitulo] = useState("");
  const [texto, setTexto] = useState("");
  const [btn, setBtn] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [cardStyle, setCardStyle] = useState("");
  const [bestProductLabel, setBestProductLabel] = useState(false);
  const [hiddenDesconto, setHiddenDesconto] = useState(false);

  useEffect(() => {
    getProdutos();
  }, []);

  const getProdutos = () => {
    if (item.length !== 0) {
      getPrice();
      setReady(true);
    }
  };
  const bestProduct = (produtoDestaque) => {
    if (produtoDestaque === "S") {
      setCardStyle("!border-2 !border-solid !border-green-connect");
      setBestProductLabel(true);
    } else {
      setCardStyle("pt-9");
      setBestProductLabel(false);
    }
  };
  const tooglePopup = () => {
    setIsOpen(!isOpen);
  };
  const reloadValues = (field, name, card, value) => {
    getPrice(name, value);
  };
  const getPrice = (name, value) => {
    if (name === undefined || value === undefined) {
      if (item[0].produ_dmvl_precocomdesconto) {
        setPrecoDe(
          parseFloat(item[0].produ_dmvl_precovenda)
            .toFixed(2)
            .toString()
            .replace(".", ",")
        );
        preco = parseFloat(item[0].produ_dmvl_precocomdesconto);
        setPrecoPor(parseFloat(preco).toFixed(2).toString().replace(".", ","));
        setHiddenDesconto(true);
      } else {
        preco = parseFloat(item[0].produ_dmvl_precovenda);
        setPrecoPor(parseFloat(preco).toFixed(2).toString().replace(".", ","));
        setHiddenDesconto(false);
      }
      setTitulo(item[0].rubri_vcds_comercial);
      setTexto(item[0].rubri_txds_conteudo);
      setBtn(item[0].rubri_inid_rubricaproduto);
      bestProduct(item[0].produ_dmsn_destaque);
    } else {
      if (item[value].produ_dmvl_precocomdesconto) {
        setPrecoDe(
          parseFloat(item[value].produ_dmvl_precovenda)
            .toFixed(2)
            .toString()
            .replace(".", ",")
        );
        preco = parseFloat(item[value].produ_dmvl_precocomdesconto);
        setPrecoPor(parseFloat(preco).toFixed(2).toString().replace(".", ","));
        setHiddenDesconto(true);
      } else {
        preco = parseFloat(item[value].produ_dmvl_precovenda);
        setPrecoPor(parseFloat(preco).toFixed(2).toString().replace(".", ","));
        setHiddenDesconto(false);
      }
      setTitulo(item[value].rubri_vcds_comercial);
      setTexto(item[value].rubri_txds_conteudo);
      setBtn(item[value].rubri_inid_rubricaproduto);
      bestProduct(item[0].produ_dmsn_destaque);
    }
  };

  const [titleFontClass, setTitleFontClass] = useState("text-lg");

  useEffect(() => {
    if (!titulo) return;
    const plain = stripHtmlTags(titulo);
    const len = plain.length;

    // Ajuste simples por número de caracteres — ajuste valores conforme necessário
    if (len <= 19) setTitleFontClass("text-lg");
    else if (len <= 29) setTitleFontClass("text-base");
    else if (len <= 180) setTitleFontClass("text-sm");
    else setTitleFontClass("text-xs");
  }, [titulo]);

  return (
    <div className="text-center">
      {isOpen && (
        <Form
          HandleClose={tooglePopup}
          content={
            <div>
              <h2>Texto</h2>
              <p>Formulário</p>
            </div>
          }
          idCertificado={btn}
          titulo={titulo}
          log={log}
        />
      )}

      {ready && (
        <div
          id={card}
          className={`
            bg-gray-100 
            text-blue-connect
            border border-gray-300 
            rounded-2xl
            m-1 p-4 
            relative
            h-[570px]
            ${cardStyle}
          `}
        >
          {bestProductLabel && (
            <div className="mb-2 flex justify-center">
              <span className="bg-green-best-seller text-blue-connect px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
                <i className="bi bi-star"></i> O mais comprado!
              </span>
            </div>
          )}

          <div className="flex justify-center my-2">
            <img src={img} alt={titulo} className="h-16" />
          </div>

          {/* título com clamp em 3 linhas e ajuste de tamanho conforme comprimento */}
          <h2
            className={`${titleFontClass} font-bold mb-2`}
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {titulo}
          </h2>

          <p className="text-sm text-blue-connect mx-2 mb-6 h-24" title={stripHtmlTags(texto)}>
            {truncateText(stripHtmlTags(texto))}
          </p>


          <select
            className="border rounded-md p-2 mt-2 w-full text-sm"
            onChange={(value) =>
              reloadValues(
                value,
                item[0]?.rubri_vcds_comercial,
                card,
                value.target.value
              )
            }
            id={item[0].rubri_vcds_comercial}
          >
            {item.map((response, index) => (
              <option key={index} value={index}>
                {response.produ_inqt_diasvalidade / 365} Ano(s)
              </option>
            ))}
          </select>

          <p className="mt-2 text-sm">Escolha o tempo do certificado</p>

          {hiddenDesconto && contexto.mostraPrecoCheio === "S" ? (
            <>
              <p className="line-through text-gray-400 text-base mt-2">R$ {precoDe}</p>
              <p className="font-bold text-lg text-blue-connect">R$ {precoPor}</p>
            </>
          ) : (
            <p className="font-bold text-lg text-blue-connect mb-12">R$ {precoPor}</p>
          )}

          <p className="mb-2 text-sm">{planoPag}</p>

          <div className="flex justify-center mt-2">
            <Button
              btnProduct
              click={tooglePopup}
              labelBtn="Comprar"
              function="tooglePopup"
              destaque={
                item[0].produ_dmsn_destaque === "S"
                  ? "btnProductDestaque"
                  : ""
              }
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default CardProductsV2;
